import type { WorkflowCompletion } from '@interfaces/workflow';
import { CalculatorVisual } from './calculator.visual';
import { useCalculator } from './useCalculator';

export const Calculator = ({
  onNext,
  options,
  stepLoading,
  subStepId,
  workflowCompletion,
}: {
  onNext: () => void;
  options: Record<string, unknown>;
  stepLoading?: boolean;
  subStepId: string;
  workflowCompletion: WorkflowCompletion;
}) => {
  const calculator = useCalculator({
    subStepId,
    stepLoading,
    workflowCompletion,
  });

  return (
    <CalculatorVisual
      calculator={calculator}
      options={options}
      onContinue={onNext}
    />
  );
};
